import { RootState } from 'store';
import { CurrentUser } from 'modules/account/types';

export const getCurrentUser = (state : RootState ) : CurrentUser | undefined => state.account.user;